/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';
import domify from 'domify';
import container from 'modules/section-content';
import splash from './pages/legal-page.pug';
import metadata from './metadata.json';
import legalPapers from './data/legalPapers.json';

export default function register() {
  page('/legal', render, display);
}

function display() {
  addClasses($('.content-menu-list li'), 'option');
  addClasses($('.section-paper-list'), 'content');
  $('.option-0').addClass('current');
  $('.content-0').addClass('show');
  checkResize();
}

function addClasses(element, classToAdd) {
  element.each((index, el) => {
    $(el).addClass(`${classToAdd}-${index}`);
  });
}

function changeTitle(title) {
  $('.title-section').empty();
  $('.title-section').append(title);
}

function checkResize() {
  if ($(window).width() < 992) {
    $('.content-menu').addClass('mobile');
    $('.content-menu-list').hide();
  } else {
    $('.content-menu').removeClass('mobile');
    $('.content-menu-list').show();
  }
}

$('.content-menu-list li').on('click', e => {
  const index = $(e.target).index();
  const textTitle = $(e.target).text();
  const icon = '<i class="icon-budicon-460 icon"></i>';
  $('.content-menu-list li').removeClass('current');
  $('.section-paper-list').removeClass('show');
  $(`.option-${index}`).addClass('current');
  $(`.content-${index}`).addClass('show');
  $('.mobile-select').html(textTitle + icon);
  changeTitle(textTitle);
  $('.mobile .content-menu-list').slideToggle(200);
});

$('.mobile-select').click(e => {
  e.preventDefault();
  $('.mobile .content-menu-list').slideToggle(200);
});

$(window).on('resize', () => {
  checkResize();
});

function render(ctx, next) {
  const renderOptions = {
    metadata,
    legalPapers,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}



// WEBPACK FOOTER //
// ./src/pages/legals/legal/legal.js